import type {TextList} from './data/types';

import useAppTheme from '../design_system/hooks/useAppTheme';
import Typography, {Size} from '../design_system/typography/Typography';

import {css} from '@emotion/react';
import {SerializedStyles} from '@emotion/serialize';
import React from 'react';

export interface Props {
  readonly textList: TextList;
  readonly style?: boolean | SerializedStyles;
}

export default function DetailTextList(props: Props): JSX.Element {
  const {style, textList} = props;
  const {palettes} = useAppTheme();
  return (
    <div
      css={[
        css({
          backgroundColor: palettes.background.neutralExtraSubdued.focus,
          padding: 24,
        }),
        style,
      ]}
    >
      <Typography variant="h2">{textList.heading}</Typography>

      <ul css={{listStyle: 'inside'}}>
        {textList.items.map((item, i) => {
          return (
            <Typography
              key={i}
              size={Size.S}
              variant="li"
            >
              {item}
            </Typography>
          );
        })}
      </ul>
    </div>
  );
}
